import type { FormConfig } from '@workwave-tidal/core/form'
import { useMemo } from 'react'

import { Footer } from './components/Footer'
import { form } from './formState'
import { useOnSubmit } from './hooks/useOnSubmit'
import { useRecurrencesMap } from './hooks/useRecurrencesMap'
import { useTexts } from './hooks/useTexts'
import type { TrafficProfileFormValues } from './types'

export function CreateTrafficProfile() {
  const recurrenceMap = useRecurrencesMap()
  const onSubmit = useOnSubmit()
  const texts = useTexts()

  const config = useMemo<FormConfig<TrafficProfileFormValues>>(
    () => ({
      id: 'traffic-profile-form',
      initialValues: {
        recurrence: undefined,
      },
    }),
    [],
  )

  return (
    <form.Form
      width={320}
      config={config}
      title={texts.trafficProfile}
      onSubmit={onSubmit}
      footer={<Footer />}
      requireTransaction
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
    >
      <form.RecurrencePickerField name="recurrence" recurrencePickerProps={{ recurrenceMap }} />
    </form.Form>
  )
}
